import ProductLogo from './ProductLogo'

export default function AuthBranding() {
  return (
    <>
      <ProductLogo className="login-product-logo" />
      <p className="login-product-expansion">
        <strong>Electronic Ledger for Auditability, Integrity and Traceability</strong><br />
        Verwalten Sie hier alle Ihre Daten rund um die Kasse im Swissbit
      </p>
    </>
  )
}
